import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router5';
import * as Actions from '../common/services/actions';
import configureStore from '../common/services/store';
import router from '../common/routes/router';
import GenericPressReleases from '../listings/GenericPressReleasesListing/GenericPressReleasesListingJsFile';


let store;


function GenericPressReleasesApp() {
	return (
		<Provider store={store}>
			<RouterProvider router={router}>
				<GenericPressReleases />
			</RouterProvider>
		</Provider>
	);
}

export function renderGenericPressReleases(id, mg, auth, micrositeRender) {

	if (!store) {
		store = configureStore(router);
	}
	
	store.dispatch(Actions.initialiseSettings('GenericPressReleasesAppId', mg, auth, micrositeRender));
	router.start(() => {
		ReactDOM.render(<GenericPressReleasesApp />, document.getElementById(id));
	});
}
